<template>
  <div class="detail-wrap">
    <el-form ref="tenant" :rules="rules" :model="tenant" :inline-message="true" class="demo-ruleForm">
      <div class="d-header clearfix">
        <div class="fl">
          <i class="el-icon-info"/>
          {{ dataId ? '查看' : '新增' }}
        </div>
        <div class="fr">
          <!--          <el-button type="primary" plain class="button-sty" @click="$baseReload()" icon="el-icon-refresh-right">重置-->
          <!--          </el-button>-->
          <el-button v-if="(addFlag && formData.id == null) || (editFlag && formData.id != null)" type="primary" class="button-sty" icon="el-icon-check" @click="saveData">保存</el-button>
        </div>
      </div>
      <div>

        <div class="d-cont edit-mce-box">
          <div class="d-item">
            <div class="title first">
              <!-- <b>创建工单</b> -->
            </div>
            <table class="table-detail">
              <tbody>
              <tr>
                <th>
                  <em class="f-red">*</em>
                  费用类型编码
                </th>
                <td class="table-row">
                  <div class="table-cell">
                    <el-input type="text" maxlength="10" autocomplete="off" v-model="formData.code" :disabled="this.isEdit" clearable
                              @blur="inspection"/>
                  </div>
                </td>
                <th>
                  <em class="f-red">*</em>
                  费用类型名称
                </th>
                <td class="table-row">
                  <div class="table-cell">
                    <el-input type="text" maxlength="10" autocomplete="off" v-model="formData.name" clearable/>
                  </div>
                </td>
                <th>
                  <em class="f-red">*</em>
                  费用名称
                </th>
                <td class="table-row">
                  <div class="table-cell">
                    <companyFeeAttributeSelect style="width:7vw"
                        :company-fee-attribute-id.sync="formData.feeAttributeId"
                      />
                  </div>
                </td>
                <th>
                  <em class="f-red">*</em>
                  排序
                </th>
                <td class="table-row">
                  <div class="table-cell">
                    <el-input type="number" min="0" max="999" autocomplete="off" v-model="formData.seq" clearable/>
                  </div>
                </td>
  
              </tr>
              <tr>
                <th>
                  <em class="f-red">*</em>
                  启用
                </th>
                <td class="table-row">
                  <div class="table-cell">
                    <el-select v-model="formData.usable">
                      <el-option label="是" :value="1"/>
                      <el-option label="否" :value="0"/>
                    </el-select>
                  </div>
                </td>
              </tr>
              <tr>
                <th>创建人</th>
                <td>{{ formData.createBy }}</td>
                <th>创建时间</th>
                <td>{{ formData.createTime }}</td>
                <th>修改人</th>
                <td>{{ formData.modifyBy }}</td>
                <th>修改时间</th>
                <td>{{ formData.modifyTime }}</td>
              </tr>
              </tbody>
            </table>
          </div>
          <div>
          </div>
        </div>
      </div>
    </el-form>

  </div>
</template>
<script>
import api from "@/api/projectApi";
import {mapGetters} from "vuex";
import companyFeeAttributeSelect from "@/components/formItem/companyFeeAttributeSelect.vue"

export default {
  inject: ['reload'],
  name: 'edit',
  props: {
    _dataId: [String, Number],
    initTableList: {
      type: Function,
      default: null
    }
  },
  components: {
    companyFeeAttributeSelect
  },
  data() {
    return {
      url: "basic/basFeeType/",
      
      addFlag: false,
      editFlag: false,

      formData: {
        id: null,
        name: null,  // 名称
        code: null,
        usable: 1,  // 是否在微信中显示:0否1是
        seq: 0,  // 排序
      },

      //  value1: true,
      value2: false,
      value3: true,
      activeName: 'first',
      isEdit: false,
      tabIndex: 'first',
      dataId: '',
    };
  },
  computed: {
    ...mapGetters(["permissions"])
  },
  created() {
    if (this._dataId && !isNaN(this._dataId)) this.dataId = this._dataId;
    // console.log(this.tenant,"tenant的值");
  },
  mounted() {
    this.addFlag = this.permissions['bas_fee_type_add']
    this.editFlag = this.permissions['bas_fee_type_edit']
    this.getData()
  },
  methods: {
    inspection() {
      if (this.formData.buyChannelName) {
        this.$http({
          url: this.url,
          method: 'get',
          data: {
            value: this.formData.buyChannelName,
            id: this.formData.id,
          }
        }).then(res => {
          if (!res.data.data) {
            this.$message.warning("购买渠道名称已存在，请重新输入")
            this.formData.buyChannelName = null
          }
        })
      }
    },

    getData() {
      if (this.dataId && !isNaN(this.dataId)) {
        this.isEdit = true;
        this.$http({
          url: this.url + this._dataId,
          method: 'get',
          // data: {
          //   id: this._dataId
          // },
          isLoading: true,
          modalStrictly: true,
        }).then(response => {
          this.formData = response.data.data;
        })
      }
    },

    saveData() {
      this.$baseConfirm('您确定要保存吗？').then(() => {
        this.$mask.open()

        let method = this.isEdit ? 'put' : 'post'
        this.$http({
          url: this.url,
          method: method,
          data: this.formData,
          isLoading: true,
        }).then(() => {
          this.$message.success("保存成功！");
          this.reload()
          this.$mask.close()
        }).catch(() => {
          this.$message.error("保存失败！");
          this.$mask.close()
        });

      });
    }
  },
};

</script>
<style lang="scss" scoped>
.table-row {
  display: flex;
  align-items: center;
  font-size: 14px;
}

.table-cell {
  flex: 1;
  margin-right: 10px;
}

</style>
